/**
 * Configuração do Discord - Notificações de Erros Frontend
 * 
 * Sistema de captura e envio de erros do frontend para o Discord
 */

export interface DiscordErrorConfig {
  endpointUrl: string;
  enabled: boolean;
  environment: string;
}

/**
 * Obtém a configuração baseada no ambiente
 */
function getConfig(): DiscordErrorConfig {
  const isProduction = import.meta.env.PROD;

  return {
    endpointUrl: `${import.meta.env.VITE_BASE_URL}/api/errors/frontend`,
    enabled: true, // Mude para false para desabilitar
    environment: isProduction ? 'production' : 'development',
  };
}

export const discordConfig = getConfig();

// ============================================
// THREAD IDs (opcional)
// ============================================
export const DISCORD_THREADS = {
  VUE_ERROR: '', // Erros do Vue
  HTTP_ERROR: '', // Erros HTTP (Axios)
  JS_ERROR: '', // Erros JavaScript
  PROMISE_ERROR: '', // Promises rejeitadas
  DEFAULT: '',
};

